<template>
  <v-container fluid class="platform-email-page">
    <NcrmHomePageHeader
      icon="mdi-email-lock-outline"
      :title="$t('admin.platformEmail.title')"
      :subtitle="$t('admin.platformEmail.subtitle')"
    />

    <v-alert type="info" class="mt-4">
      {{ $t("admin.platformEmail.boundaryNotice") }}
    </v-alert>

    <div class="platform-email-page__grid mt-4">
      <PlatformEmailSmtpCard />
      <PlatformEmailTemplatesCard />
    </div>
  </v-container>
</template>

<script>
import NcrmHomePageHeader from "@/components/ncrm/shared/NcrmHomePageHeader.vue";
import PlatformEmailSmtpCard from "./platform-email/PlatformEmailSmtpCard.vue";
import PlatformEmailTemplatesCard from "./platform-email/PlatformEmailTemplatesCard.vue";

export default {
  name: "PlatformEmailSettings",
  components: { NcrmHomePageHeader, PlatformEmailSmtpCard, PlatformEmailTemplatesCard },
};
</script>

<style scoped>
.platform-email-page {
  min-height: 100%;
  background: var(--app-page-background);
}

.platform-email-page__grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 16px;
  align-items: start;
}

@media (max-width: 1100px) {
  .platform-email-page__grid { grid-template-columns: minmax(0, 1fr); }
}
</style>
